// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "documentFieldsItem-1M5jy";
var _4 = "documentFieldsItem__remove-1oFB0";
var _5 = "buttonRemove-3PGfI";
var _6 = "input-3PujL";
var _7 = "dropdown-2dMaD";
var _8 = "documentFieldsItem__controls-qS3yq";
export { _1 as "__esModule", _2 as "mobile", _3 as "documentFieldsItem", _4 as "documentFieldsItem__remove", _5 as "buttonRemove", _6 as "input", _7 as "dropdown", _8 as "documentFieldsItem__controls" }
export default { "__esModule": _1, "mobile": _2, "documentFieldsItem": _3, "documentFieldsItem__remove": _4, "buttonRemove": _5, "input": _6, "dropdown": _7, "documentFieldsItem__controls": _8 }
